import type { WorkspaceMark } from "./mark";
export const WorkspaceMarkFrame = ({ mark }: { mark: WorkspaceMark }) =>
  mark.color ? (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        boxShadow: `inset 0 0 24px 4px ${mark.color}`,
        pointerEvents: "none",
        zIndex: 1000,
      }}
    />
  ) : null;
